import React from 'react';
import {
    Box,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Paper,
    IconButton,
    Button,
    Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

interface TaskOption {
  option_id: number;
  question_id: number;
    option_en: string;
  option_hi: string;
}

interface HintStep {
  step_id: number;
  step_en: string;
  step_hi: string;
  step_icon: string;
}

interface Hint {
  hint_id: number;
  hint_en: string;
  hint_hi: string;
  hint_steps: HintStep[];
}

interface QuestionDetails {
  question_id: number;
  question_no: number;
  question_en: string;
  question_hi: string;
  question_type_en: string;
  question_type_hi: string;
  sample_picture: string;
  points: number;
  task_options: TaskOption[];
  hint: Hint[];
}


interface QuestionCardProps {
  questionsdetailsmain: QuestionDetails[];
}

const QuestionCard: React.FC<QuestionCardProps> = ({ questionsdetailsmain }) => {
    const [value, setValue] = React.useState('');
    const [showError, setShowError] = React.useState(false);

    const correctAnswer = '₹340 for 20s pack';

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = event.target.value;
        setValue(selected);
        setShowError(selected !== correctAnswer);
    };

    const handleRetry = () => {
        setValue('');
        setShowError(false);
    };
console.log(questionsdetailsmain, "questionsdetailsmainkkkkkkkkk")
    const question = questionsdetailsmain[0]; // Assume first question if only one shown

    if (!question) return null;

 return (
        <Box
            sx={{
                maxWidth: 400,
                margin: 'auto',
                padding: 2,
                borderRadius: 2,
                background: '#fff',
                border: '1px solid #e0e0e0',
            }}
        >
            {/* Error Banner */}
            {showError && (
                <Alert severity="error" icon={<ErrorIcon />} sx={{ mb: 2 }}>
                    Wrong answer, please select again
                </Alert>
            )}

            {/* Banner Image */}
          {questionsdetailsmain.map((item, index) => (
  <Box key={index} sx={{ mb: 4 }}>
    {/* Question Image */}
    {item.sample_picture && (
      <img
        src={`${process.env.REACT_APP_API_URL}${item.sample_picture}`}
        alt="Question"
        crossOrigin="anonymous"
        style={{ width: '100%', borderRadius: '8px' }}
      />
    )}

    {/* Question Text */}
    <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
      {item.question_en || 'Question text here'}
    </Typography>

    

    {/* Options Section */}
    <FormControl component="fieldset" fullWidth>
      <RadioGroup value={value} onChange={handleChange}>
        {item.task_options.map((option: TaskOption) => {
  const isSelected = value === option.option_en;
  const isWrong = showError && isSelected;

          return (
            <Paper
              key={option.option_id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1,
                mb: 1.5,
                boxShadow: "none",
                borderRadius: 2,
                border: isWrong
                  ? '2px solid #D32F2F'
                  : isSelected
                    ? '2px solid #1976D2'
                    : '1px solid #ccc',
                backgroundColor: isSelected ? 'rgb(240, 206, 206)' : '#fff',
                cursor: 'pointer',
              }}
              onClick={() => {
                setValue(option.option_en);
                setShowError(option.option_en !== correctAnswer);
              }}
            >
              <Typography sx={{ fontSize: '15px' }}>{option.option_en}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {!isSelected && <Radio />}
                {isSelected && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setValue('');
                      setShowError(false);
                    }}
                  >
                    <CloseIcon sx={{ color: "#fff", background: "#D32F2F", borderRadius: "50%" }} fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Paper>
          );
        })}
      </RadioGroup>
    </FormControl>
  </Box>
))}


            {/* Try Again Button */}
            <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleRetry}
                    fullWidth
                    sx={{ py: 1 }}
                >
                    Try Again
                </Button>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 1, display: 'block' }}
                >
                    For Trade Only. Not for Distribution to Consumers.
                </Typography>
            </Box>
        </Box>
    );
};

export default QuestionCard;

